/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Done_SubInputs */

const en_funnel_done_sub = /** @type {(inputs: Funnel_Done_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first paper is queued and ready to play.`)
};

const es_funnel_done_sub = /** @type {(inputs: Funnel_Done_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu primer artículo está en cola y listo para reproducir.`)
};

/**
* | output |
* | --- |
* | "Your first paper is queued and ready to play." |
*
* @param {Funnel_Done_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_done_sub = /** @type {((inputs?: Funnel_Done_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Done_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_done_sub(inputs)
	return en_funnel_done_sub(inputs)
});